export const cardArray = [
  { type: 'notHeb', id: '1', url: 'img/coal', ru: 'уголь', en: 'coal' },
  { type: 'heb', id: '1h', heb: 'פחמים' },

  { type: 'notHeb', id: '2', url: 'img/loneliness', ru: 'одиночество', en: 'loneliness' },
  { type: 'heb', id: '2h', heb: 'בדידות' },

  { type: 'notHeb', id: '3', url: 'img/shark', ru: 'акула', en: 'shark' },
  { type: 'heb', id: '3h', heb: 'כריש' },

  { type: 'notHeb', id: '4', url: 'img/painting', ru: 'картина', en: 'painting' },
  { type: 'heb', id: '4h', heb: 'ציור' },

  { type: 'notHeb', id: '5', url: 'img/reward', ru: 'награда', en: 'reward' },
  { type: 'heb', id: '5h', heb: 'גמול' },

  { type: 'notHeb', id: '6', url: 'img/risk', ru: 'риск', en: 'risk' },
  { type: 'heb', id: '6h', heb: 'סכון' },

  { type: 'notHeb', theme: 'university', id: '7', url: 'img/university', ru: 'университет', en: 'university' },
  { type: 'heb', theme: 'university', id: '7h', heb: 'אוניברסיטה' },

  { type: 'notHeb', theme: 'university', id: '8', url: 'img/lecture', ru: 'лекция', en: 'lecture' },
  { type: 'heb', theme: 'university', id: '8h', heb: 'הרצאה' },

  { type: 'notHeb', theme: 'university', id: '9', url: 'img/library', ru: 'библиотека', en: 'library' },
  { type: 'heb', theme: 'university', id: '9h', heb: 'ספרייה' },

  { type: 'notHeb', theme: 'university', id: '10', url: 'img/presentation', ru: 'презентация', en: 'presentation' },
  { type: 'heb', theme: 'university', id: '10h', heb: 'מצגת' },

  { type: 'notHeb', theme: 'university', id: '11', url: 'img/laboratory', ru: 'лаборатория', en: 'laboratory' },
  { type: 'heb', theme: 'university', id: '11h', heb: 'מעבדה' },

  { type: 'notHeb', theme: 'university', id: '12', url: 'img/dormitory', ru: 'общежитие', en: 'dormitory' },
  { type: 'heb', theme: 'university', id: '12h', heb: 'מעונות' },

  { type: 'notHeb', theme: 'university', id: '13', url: 'img/practice', ru: 'практика', en: 'practice' },
  { type: 'heb', theme: 'university', id: '13h', heb: 'תרגול' },

  { type: 'notHeb', theme: 'football', id: '14', url: 'img/ball', ru: 'мяч', en: 'ball' },
  { type: 'heb', theme: 'football', id: '14h', heb: 'כדור' },

  { type: 'notHeb', theme: 'football', id: '15', url: 'img/gates', ru: 'ворота', en: 'gates' },
  { type: 'heb', theme: 'football', id: '15h', heb: 'שער' },

  { type: 'notHeb', theme: 'football', id: '16', url: 'img/goalkeeper', ru: 'вратарь', en: 'goalkeeper' },
  { type: 'heb', theme: 'football', id: '16h', heb: 'שוער' },

  { type: 'notHeb', theme: 'football', id: '17', url: 'img/player', ru: 'игрок', en: 'player' },
  { type: 'heb', theme: 'football', id: '17h', heb: 'שחקן' },

  { type: 'notHeb', theme: 'football', id: '18', url: 'img/field', ru: 'поле', en: 'field' },
  { type: 'heb', theme: 'football', id: '18h', heb: 'מגרש' },

  { type: 'notHeb', id: '19', url: 'img/shoes', ru: 'обувь', en: 'shoes' },
  { type: 'heb', id: '19h', heb: 'נעליים' },

  { type: 'notHeb', theme: 'football', id: '20', url: 'img/coach', ru: 'тренер', en: 'coach' },
  { type: 'heb', theme: 'football', id: '20h', heb: 'מאמן' },

  { type: 'notHeb', theme: 'football', id: '21', url: 'img/whistle', ru: 'свисток', en: 'whistle' },
  { type: 'heb', theme: 'football', id: '21h', heb: 'שריקה' },

  { type: 'notHeb', theme: 'football', id: '22', url: 'img/card', ru: 'карточка', en: 'card' },
  { type: 'heb', theme: 'football', id: '22h', heb: 'כרטיס' },

  { type: 'notHeb', theme: 'football', id: '23', url: 'img/goblet', ru: 'кубок', en: 'goblet' },
  { type: 'heb', theme: 'football', id: '23h', heb: 'גביע' },

  { type: 'notHeb', theme: 'university', id: '24', url: 'img/diploma', ru: 'диплом', en: 'diploma' },
  { type: 'heb', theme: 'university', id: '24h', heb: 'תעודת הסמכה'},

    { type: 'notHeb', theme: 'school', id: '25', url: 'img/school', ru: 'школа', en: 'school' },
  { type: 'heb', theme: 'school', id: '25h', heb: 'בית ספר' },

  { type: 'notHeb', theme: 'school', id: '26', url: 'img/classroom', ru: 'класс', en: 'classroom' },
  { type: 'heb', theme: 'school', id: '26h', heb: 'כיתה' },

  { type: 'notHeb', theme: 'school', id: '27', url: 'img/teacher', ru: 'учитель', en: 'teacher' },
  { type: 'heb', theme: 'school', id: '27h', heb: 'מורה' },

  { type: 'notHeb', theme: 'school', id: '28', url: 'img/student', ru: 'ученик', en: 'student' },
  { type: 'heb', theme: 'school', id: '28h', heb: 'תלמיד' },

  { type: 'notHeb', theme: 'school', id: '29', url: 'img/notebook', ru: 'тетрадь', en: 'notebook' },
  { type: 'heb', theme: 'school', id: '29h', heb: 'מחברת' },

  { type: 'notHeb', theme: 'school', id: '30', url: 'img/blackboard', ru: 'доска', en: 'blackboard' },
  { type: 'heb', theme: 'school', id: '30h', heb: 'לוח' },

  { type: 'notHeb', theme: 'school', id: '31', url: 'img/backpack', ru: 'рюкзак', en: 'backpack' },
  { type: 'heb', theme: 'school', id: '31h', heb: 'תיק גב' },

  { type: 'notHeb', theme: 'school', id: '32', url: 'img/pencil', ru: 'карандаш', en: 'pencil' },
  { type: 'heb', theme: 'school', id: '32h', heb: 'עיפרון' }
];

export function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) { 
    let j = Math.floor(Math.random() * (i + 1)); 
    [array[i], array[j]] = [array[j], array[i]]; 
  }
  return array;
}